<template>
  <a-modal
    :visible="visible"
    title="修改密码"
    @ok="submit"
    @cancel="close"
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <a-form-item label="旧密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-password
          v-decorator="[
            'oldPwd',
            { rules: [{ required: true, message: '请填写旧密码' }] }
          ]"
        ></a-input-password>
      </a-form-item>
      <a-form-item label="新密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-password
          v-decorator="[
            'newPwd',
            { rules: [{ required: true, message: '请填写新密码' }] }
          ]"
        ></a-input-password>
      </a-form-item>
      <a-form-item
        label="确认密码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        :required="true"
        :validateStatus="validateStatus"
        :help="errorMsg"
      >
        <a-input-password v-model="tempNewPwd"></a-input-password>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { updatePassWord } from "@/api/system/user";

export default {
  data() {
    return {
      //modal
      visible: false,
      loading: false,
      //form
      form: this.$form.createForm(this),
      labelCol: { md: { span: 7 }, sm: { span: 24 } },
      wrapperCol: { md: { span: 12 }, sm: { span: 24 } },
      tempNewPwd: "",
      validateStatus: "error",
      errorMsg: "两次输入密码不同"
    };
  },
  watch: {
    newPwd() {
      if (this.tempNewPwd === this.form.getFieldValue("newPwd")) {
        this.validateStatus = "success";
        this.errorMsg = null;
      } else {
        this.validateStatus = "error";
        this.errorMsg = "两次输入密码不同";
      }
    },
    tempNewPwd() {
      if (this.tempNewPwd === this.form.getFieldValue("newPwd")) {
        this.validateStatus = "success";
        this.errorMsg = null;
      } else {
        this.validateStatus = "error";
        this.errorMsg = "两次输入密码不同";
      }
    }
  },
  methods: {
    submit() {
      if (this.errorMsg) return;
      this.form.validateFields((err, values) => {
        this.loading = true;
        if (!err) {
          updatePassWord({ ...values }).then(res => {
            console.log(res);
            if (res.resultCode === 1) {
              this.$notification.success({
                message: res.message,
                description: "正在跳转登录页面"
              });
              this.close();
              setTimeout(() => {
                this.$store.dispatch("Logout").then(() => {
                  this.$router.push({ name: "login" });
                });
              }, 1500);
            } else {
              this.$notification.error({
                message: res.message
              });
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
    show() {
      this.visible = true;
    },
    close() {
      this.form.resetFields();
      this.visible = false;
    }
  }
};
</script>
<style></style>
